/**
 * Code-level product switches for the web client (the desktop app shares them).
 *
 * Session sharing is hidden while its cross-client story is settled: the phone
 * clients never offered it. The component, API and read-only shared view stay,
 * so turning this back on restores the header control.
 */
export const ENABLE_SESSION_SHARING = false
